import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3TitleCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
    this.renderFailIntro = this.renderFailIntro.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails,
      failIntro: this.renderFailIntro
    }

    return <V3Check { ...props } />
  }

  renderFailIntro() {
    if (this.props.check.checkItems[0].details) {
      return (
        <div>
          <h3>What's wrong</h3>
          <p>The image alt tag is missing or empty for the following {this.props.check.checkItems[0].details.length} images:</p>
        </div>
      )
    }

    return (
      <div>
        <h3>What's wrong</h3>
      </div>
    )
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            It's the alt attribute on the HTML image tag &lt;img src="image_filename.png" alt="Alt tag text here"/&gt;
          </p>
          <p>
            All images should have an alt tag describing its content. 
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used in search engine algorithms</li>
            <li>Visible to users only when hovering over the image, if it can't load or if they're using accessibility features</li>
            <li>You guide search engines on what the image is of by adding an ALT tag to it</li>
            <li>Keywords here make it more likely the image turns up in image search too</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Add an alt tag to all images</li>
            <li>Describe the image in at most a sentence</li>
            <li>Images with text within are worse than simply plain text, but adding an alt tag is an improvement</li>
          </ul>
          <hr />
        </div>

        <div>
          <h2>Fix this yourself</h2>
          <h3>Products</h3>
          <p>
            Product pages are created using the product.liquid template. Edit this template for product images to include the ALT tag.
          </p>
          <ol>
            <li>Themes &gt; Template Editor &gt; product.liquid</li>
            <li>Find the img tag containing a src like &#123;&#123; image | product_img_url: 'large' &#125;&#125;</li>
            <li>Add a new attribute alt="&#123;&#123; product.title | escape &#125;&#125;"</li>
          </ol>
          <h3>Blogs &amp; Pages</h3>
          <p>
            When placing images on your blog posts and pages, set a description for the image. This will become its alt tag, no template editing required.
          </p>
          <h3>Other</h3>
          <p>
            If there are other pages on your site not driven by Product, Blogs or Pages, there will be a liquid template for it. Generally, find the template, locate any img tags, and try to drive the alt from <a href="http://wiki.shopify.com/VariableReference">a liquid variable</a>.
          </p>

          <h3>Images used for buttons, logos, icons etc.</h3>
          <p>Adding an alt tag to these type of images is less important for SEO (except for your logo, which is worthwhile to do).</p>
          <p>The process is different for every type of image, but in general you find the appropriate template in your theme (say, theme.liquid for your logo), find the image and add the alt attribute to the image.</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3ImagesCheck.js